module.exports = __webpack_public_path__ + "img/test_03.5e2126d3.jpg";